"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'rag.file.indexing_error': 'L\'indicizzazione del file è fallita. Per favore riprova o contatta il supporto se il problema persiste.',
};
